export default "__VITE_ASSET__$Lsg40vT__"